
    <fieldmagic-icon
      id="btnMultipleUpdate"
      icon="pencil"
      (click)="openUpdateDialog()"
    >
      <span>{{ 'bulk_update' | translate }}</span>
    </fieldmagic-icon>
  